import styled from 'styled-components'

export const Page = styled.div`
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
    overflow-x: visible;
    padding-bottom: 80px;
    color: #111827;

    *,
    *::before,
    *::after {
        box-sizing: border-box;
    }

    .ui.form,
    .ui.message,
    .ui.header {
        max-width: 100%;
    }

    .ui.header {
        margin-top: 0 !important;
    }

    .ui.form .fields > .field {
        min-width: 0;
    }

    .ui.selection.dropdown {
        min-width: 0 !important;
        max-width: 100%;
    }

    .page-head {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        gap: 12px;
        flex-wrap: wrap;
        margin-bottom: 8px;
        width: 100%;
    }

    .excel-check .d-flex {
        flex-wrap: wrap;
        max-width: 100%;
    }

    .excel-actions {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        align-items: center;
        margin: 8px 0;
    }

    .recon {
        display: flex;
        gap: 10px;
        align-items: flex-start;
        padding: 12px;
        border: 1px solid #bbf7d0;
        background: #f0fdf4;
        border-radius: 6px;
        margin: 16px 0;
        font-size: 13px;
        word-break: break-word;
    }
    .recon.fail {
        border-color: #fecaca;
        background: #fef2f2;
    }
    .recon .check {
        flex-shrink: 0;
        font-weight: 700;
    }

    .page-sub {
        color: #6b7280;
        font-size: 13px;
        margin: 0 0 16px;
        word-break: break-word;
    }

    .lang-toggle {
        display: inline-flex;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        overflow: hidden;
        flex-shrink: 0;
    }
    .lang-toggle button {
        border: 0;
        background: #fff;
        padding: 8px 12px;
        font-size: 12px;
        font-weight: 700;
        cursor: pointer;
        color: #6b7280;
    }
    .lang-toggle button.active {
        background: #2185d0;
        color: #fff;
    }

    .toolbar {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
    }

    .excel-hint {
        color: #6b7280;
        font-size: 12px;
        margin: 0 0 12px;
        max-width: 100%;
        white-space: normal;
        word-break: break-word;
        overflow-wrap: anywhere;
    }

    .kpis {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin: 16px 0;
        width: 100%;
    }
    .kpi {
        flex: 1 1 200px;
        min-width: 0;
        max-width: 100%;
        background: #fff;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 12px 14px;
    }
    .kpi .lbl {
        font-size: 11px;
        color: #6b7280;
        text-transform: uppercase;
        letter-spacing: 0.04em;
        font-weight: 600;
        margin-bottom: 6px;
    }
    .kpi .val {
        font-size: 22px;
        font-weight: 700;
        line-height: 1.2;
        word-break: break-word;
    }
    .kpi .val.pos {
        color: #15803d;
    }
    .kpi .val.warn {
        color: #a16207;
    }
    .kpi .val.neg {
        color: #b91c1c;
    }
    .kpi .hint {
        font-size: 11px;
        color: #6b7280;
        margin-top: 4px;
        word-break: break-word;
    }

    .url-line {
        display: block;
        margin-top: 8px;
        font-size: 12px;
        font-family: monospace;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 100%;
    }

    .nav {
        display: flex;
        flex-wrap: wrap;
        gap: 8px;
        margin: 16px 0;
    }
    .nav button {
        border: 1px solid #e5e7eb;
        background: #f9fafb;
        border-radius: 6px;
        padding: 8px 12px;
        font-size: 12px;
        cursor: pointer;
        color: #374151;
    }
    .nav button.active {
        background: #fff;
        border-color: #2185d0;
        color: #2185d0;
        font-weight: 600;
    }

    .chart-card {
        border: 1px solid #e5e7eb;
        border-radius: 6px;
        padding: 16px;
        margin: 16px 0;
        width: 100%;
        min-width: 0;
        overflow: hidden;
    }
    .chart-card h3 {
        margin: 0 0 4px;
        font-size: 15px;
    }
    .chart-card .desc {
        color: #6b7280;
        font-size: 12px;
        margin-bottom: 16px;
        word-break: break-word;
    }
    .chart {
        display: grid;
        grid-template-columns: minmax(64px, 90px) minmax(0, 1fr) 48px;
        gap: 8px 10px;
        align-items: center;
        font-size: 12px;
        width: 100%;
    }
    .chart .lbl {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .chart .track {
        position: relative;
        background: #f3f4f6;
        border-radius: 4px;
        height: 18px;
        overflow: hidden;
        min-width: 0;
    }
    .chart .bar {
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border-radius: 4px;
        background: #2185d0;
    }
    .chart .bar.ok {
        background: #15803d;
    }
    .chart .bar.amber {
        background: #a16207;
    }
    .chart .bar.bad {
        background: #b91c1c;
    }
    .chart .val {
        text-align: right;
        font-weight: 600;
    }
    .chart .target {
        position: absolute;
        top: -2px;
        bottom: -2px;
        width: 2px;
        background: #2185d0;
        opacity: 0.6;
    }

    .as-h2 {
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 8px;
        margin: 24px 0 8px;
        font-size: 16px;
    }
    .as-h2 .num {
        display: inline-flex;
        width: 22px;
        height: 22px;
        align-items: center;
        justify-content: center;
        background: #2185d0;
        color: #fff;
        border-radius: 50%;
        font-size: 11px;
        font-weight: 700;
    }
    .as-h2 .info {
        margin-left: auto;
        font-size: 12px;
        color: #6b7280;
        font-weight: 500;
    }

    .tbl-wrap {
        width: 100%;
        max-width: 100%;
        overflow-x: auto;
        margin-bottom: 8px;
        border: 1px solid #e5e7eb;
        border-radius: 6px;
    }
    table.as-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 13px;
        min-width: 480px;
    }
    table.as-table th,
    table.as-table td {
        padding: 8px 12px;
        border-bottom: 1px solid #f3f4f6;
        text-align: right;
    }
    table.as-table th:first-child,
    table.as-table td:first-child {
        text-align: left;
    }
    table.as-table thead th {
        background: #f9fafb;
        text-transform: uppercase;
        font-size: 11px;
        color: #6b7280;
        white-space: nowrap;
    }
    table.as-table tr.promedio td {
        background: #f0f8ff;
        font-weight: 700;
        color: #1e40af;
    }
    table.as-table tr.total td {
        background: #f9fafb;
        font-weight: 700;
    }

    .pill {
        display: inline-block;
        padding: 3px 10px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        min-width: 48px;
        text-align: center;
    }
    .pill.ok {
        background: #dcfce7;
        color: #15803d;
    }
    .pill.amber {
        background: #fef3c7;
        color: #a16207;
    }
    .pill.bad {
        background: #fee2e2;
        color: #b91c1c;
    }
    .pill.blank {
        background: repeating-linear-gradient(
            45deg,
            #fafafa,
            #fafafa 4px,
            #f3f4f6 4px,
            #f3f4f6 8px
        );
        color: #6b7280;
        font-style: italic;
    }

    .legend {
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        padding: 12px 0;
        font-size: 12px;
        color: #6b7280;
    }
    .legend .item {
        display: inline-flex;
        align-items: center;
        gap: 8px;
    }
    .legend .sw {
        width: 28px;
        height: 12px;
        border-radius: 3px;
        display: inline-block;
        flex-shrink: 0;
    }

    .footer-meta {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        flex-wrap: wrap;
        font-size: 12px;
        color: #6b7280;
        margin-top: 16px;
        padding: 12px 0 24px;
        border-top: 1px solid #e5e7eb;
        word-break: break-word;
    }

    @media (max-width: 930px) {
        .kpis .kpi {
            flex: 1 1 100%;
        }
        .ui.form .fields {
            display: block !important;
        }
        .ui.form .fields > .field {
            width: 100% !important;
            padding: 0 !important;
            margin: 0 0 1em !important;
        }
        .as-h2 .info {
            margin-left: 0;
            width: 100%;
        }
        .chart {
            grid-template-columns: 72px minmax(0, 1fr) 44px;
        }
    }

    @media print {
        .no-print {
            display: none !important;
        }
    }
`
